import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var CoopSearchTableRow = function (_a) {
    var id = _a.id, memberLimit = _a.memberLimit, level = _a.level, name = _a.name, memberCount = _a.memberCount, onClick = _a.onClick;
    return (React.createElement("div", { className: "tr " + IdStyles.TableRowRankingBig + " mouse-hover", onClick: onClick },
        React.createElement("div", { className: "td" },
            React.createElement(Icon, { icon: IdIcon.CoopXpIcn, styleId: "flex flex--guts " + IdStyles.IconMedium },
                React.createElement("div", { className: "coop-search-level-text" },
                    React.createElement(NumberFormat, { className: IdStyles.TextSmallBoldSecondaryOutline, amount: level })))),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" }, name),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" }, memberCount + "/" + memberLimit),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" },
            React.createElement(Icon, { icon: IdIcon.OpenAllianceIcn, styleId: IdStyles.IconMedium }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/CoopSearchTableRow.tsx
// module id = 2624
// module chunks = 3